import axiosInstance from "../api/axiosConfig";

export const getSystemInfo = async () => {
    try {
        const response = await axiosInstance.get("/system");
        return response.data;
    } catch {
        return null;
    }
}
